import { useLanguage } from '../i18n';
import StyledMarkdown from '../components/StyledMarkdown';

interface InterviewDocumentProps {
  workingDoc: string;
}

export default function InterviewDocument({ workingDoc }: InterviewDocumentProps) {
  const { t } = useLanguage();
  const i = t.interview;

  return (
    <div className="bg-white border border-cloud p-4 sm:p-5 h-full overflow-y-auto">
      <h3 className="text-sm font-semibold text-slate uppercase tracking-wider mb-3">{i.documentTitle}</h3>
      {workingDoc.trim() ? (
        <StyledMarkdown content={workingDoc} />
      ) : (
        <p className="text-sm text-ash italic">{i.documentEmpty}</p>
      )}
    </div>
  );
}
